import {api as gridApi} from './cocTestsViewGridActions';
import * as qplsService from '../../services/Qpls/qplsService';
import Network from 'infrastructure/js/modules/network';
import {api as messageDialogApi} from '../MessageDialog/messageDialogActions';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  COC_VIEW_FETCH_DATA_READY: 'COC_VIEW_FETCH_DATA_READY',
  COC_VIEW_SET_BUSY: 'COC_VIEW_SET_BUSY',
  COC_VIEW_CLEAR_DATA: 'COC_VIEW_CLEAR_DATA',
  COC_VIEW_UNMOUNT: 'COC_VIEW_UNMOUNT',
  COC_VIEW_SET_COC_ID: 'COC_VIEW_SET_COC_ID',
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  fetchDataReady: function(payload) {
    return {type: actionTypes.COC_VIEW_FETCH_DATA_READY, payload: payload};
  },
  setBusy: function(payload) {
    return {type: actionTypes.COC_VIEW_SET_BUSY, payload: payload};
  },
  clearData: function(payload) {
    return {type: actionTypes.COC_VIEW_CLEAR_DATA, payload: payload};
  },
  setCoCId: function(payload) {
    return {type: actionTypes.COC_VIEW_SET_COC_ID, payload: payload };
  },
  unmount: function(items) {
    return {type: actionTypes.COC_VIEW_UNMOUNT};
  },
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.reload = function() {
  return function(dispatch, getState) {
    gridApi.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};

jsxActions.setCoCId = function (cocId) {
  return function (dispatch, getState) {
    dispatch(actions.setCoCId(cocId));
  }
};

jsxActions.init = function (cocId) {
  return function (dispatch, getState) {
    return api.fetchData(dispatch, getState)(cocId);
  }
};

jsxActions.unmount = function() {
  return function(dispatch, getState) {
    dispatch(actions.unmount());
  }
};



/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.fetchData = function(dispatch, getState) {
  return function(cocId ) {
    return qplsService.getCoCDetails(cocId).then((response) => {

      if (!Network.isResponseValid(response)) {
        console.error('Get CoC data failed', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return { success: false };
      }
      return response?.data;
    });
  }
};



